import {useState} from 'react'

export type Sort<T extends string> = {
  orderBy: T
  orderDirection: 'ASC' | 'DESC'
}

export type SortApi<T extends string> = {
  value: Sort<T>
  change: (value: Sort<T> | ((prevState: Sort<T>) => Sort<T>)) => void
}

/**
 * The goal of this hook is to unify sort state with generic types in single API object.
 * This should help devs to define list of sortable fields and use object in sort control components.
 */
export function useSort<T extends string>(defaultSort: Sort<T>): SortApi<T> {
  const [sort, setSort] = useState(defaultSort)

  return {value: sort, change: setSort}
}

